<script setup lang="ts">
import { useAttrs } from 'vue';
import ItpFormSelect from './ItpFormSelect.vue';

defineOptions({ name: 'ItpFormSearchableSelect', inheritAttrs: false });

const props = defineProps<{ name: string }>();

if (import.meta.env.DEV) {
  const { nullOption } = useAttrs();
  if (nullOption != null && nullOption !== false) {
    console.warn(
      `ItpFormSearchableSelect "${props.name}": nullOption only works in ItpFormNativeSelect. Use clearable here.`,
    );
  }
}
</script>

<template>
  <ItpFormSelect v-bind="$attrs" :name="props.name" mode="rich">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </ItpFormSelect>
</template>
